import React from "react"

import { Link } from "react-router-dom"
import { gql, useQuery } from "urql"

import { Box, Button, Heading, PseudoBox, useTheme } from "@chakra-ui/core"

import LocalTime from "components/LocalTime"
import Layer from "components/Pages/Layer"
import ErrorBoundary from "components/Pages/Teacher/ErrorBoundary"
import UrqlLoadingIndicator from "components/WithLoadingIndicator/urql"

const AirClassroomsPage = () => {
  const theme: any = useTheme()
  const [result] = useQuery({ query: airClassroomsQuery })

  return (
    <Layer>
      <ErrorBoundary name="AirClassrooms">
        <Heading fontSize="3xl" height="16" maxW="50%" isTruncated>
          Air Classrooms
        </Heading>

        <UrqlLoadingIndicator result={result}>
          {({ data }) => (
            <>
              {data.viewer.audioRoom ? (
                <Button
                  as={Link}
                  to="/air-classrooms/room"
                  size="md"
                  mb="6"
                  {...theme.buttonVariants.cloudroom}
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  Join Audio Room
                </Button>
              ) : null}

              {data.viewer.todaysAcrClassPeriods.length > 0 ? (
                <section>
                  <Heading fontSize="xl" height="10" maxW="50%" isTruncated>
                    Today's Classes
                  </Heading>
                  <Box as="table" minW="containers.md" w="full">
                    <thead>
                      <tr>
                        <Box as="th" textAlign="left">
                          Class Name
                        </Box>
                        <Box as="th" textAlign="left">
                          Time
                        </Box>
                        <Box as="th" textAlign="left">
                          Subject
                        </Box>
                        <Box as="th" textAlign="left">
                          Grade
                        </Box>
                      </tr>
                    </thead>
                    <tbody>
                      {data.viewer.todaysAcrClassPeriods.map(acrClassPeriod => (
                        <PseudoBox
                          as="tr"
                          key={acrClassPeriod.id}
                          borderBottom="1px"
                          borderBottomColor="gray.400"
                          _last={{ border: "none" }}
                        >
                          <Box
                            as="td"
                            py="3"
                            // color="blue.700"
                            // textDecoration="underline"
                          >
                            {/* <Link
                              to={`/air-classrooms/${acrClassPeriod.acrClass.id}/details`}
                            > */}
                            {acrClassPeriod.acrClass.name}
                            {/* </Link> */}
                          </Box>
                          <Box as="td" py="3">
                            <LocalTime
                              omitDate
                              timestamp={acrClassPeriod.startsAt}
                            />
                            &nbsp;&mdash;&nbsp;
                            <LocalTime
                              omitDate
                              timestamp={acrClassPeriod.endsAt}
                            />
                          </Box>
                          <Box as="td" py="3">
                            {acrClassPeriod.acrClass.subject.name}
                          </Box>
                          <Box as="td" py="3">
                            {acrClassPeriod.acrClass.grade.name}
                          </Box>
                        </PseudoBox>
                      ))}
                    </tbody>
                  </Box>
                </section>
              ) : (
                <Heading fontSize="lg" height="8" maxW="50%" isTruncated>
                  No classes today!
                </Heading>
              )}
            </>
          )}
        </UrqlLoadingIndicator>
      </ErrorBoundary>
    </Layer>
  )
}

const airClassroomsQuery = gql`
  query TeacherAirClassrooms {
    viewer {
      id
      audioRoom {
        id
      }
      todaysAcrClassPeriods {
        id
        startsAt
        endsAt
        acrClass {
          id
          name
          subject {
            id
            name
          }
          grade {
            id
            name
          }
        }
      }
    }
  }
`

export default AirClassroomsPage
